import { IQualification, QualificationType } from '@medely/types';
import useGraphQLRequest from './useGraphQLRequest';
import { DEFAULT_REFETCH_INTERVAL, GET_QUALIFICATIONS } from '@mp';
import { QueryFunctionContext, useQuery } from '@tanstack/react-query';

export type UseQualificationsInput = {
  excludeSlugs?: string[];
  qualificationType: QualificationType;
  refetch?: boolean;
};

type UseQualificationsResult = {
  isLoading: boolean;
  qualifications: IQualification[];
};

const useQualifications = ({
  excludeSlugs = [],
  qualificationType,
  refetch,
}: UseQualificationsInput): UseQualificationsResult => {
  const { request } = useGraphQLRequest();

  const getQualifications = async ({
    queryKey: [_entity, qualification_type, excludeSlugs],
  }: QueryFunctionContext<[unknown, QualificationType, string[]]>) => {
    const sanitizedExcludeSlugs = excludeSlugs.filter((slug) => slug !== 'caps_check');
    const { qualifications } = await request(GET_QUALIFICATIONS, {
      input: {
        search: { exclude_slugs: [...sanitizedExcludeSlugs, 'caps_check'] },
        filter: { qualification_type, status: 'active' },
        orderBy: { long_name: true },
      },
    });
    return qualifications;
  };

  const { data, isLoading } = useQuery(
    ['qualifications', qualificationType, excludeSlugs],
    getQualifications,
    {
      refetchInterval: refetch ? DEFAULT_REFETCH_INTERVAL : undefined,
    },
  );

  return {
    qualifications: data ?? [],
    isLoading: isLoading,
  };
};

export default useQualifications;
